var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCursorText = function SvgIconCursorText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5 4.5a1 1 0 0 1 1-1H9a4 4 0 0 1 3 1.354q.082-.093.172-.182A4 4 0 0 1 15 3.5h1.5a1 1 0 1 1 0 2H15a2 2 0 0 0-2 2V11h1.25a1 1 0 1 1 0 2H13v3.5a2 2 0 0 0 2 2h1.5a1 1 0 1 1 0 2H15a4 4 0 0 1-3-1.354A4 4 0 0 1 9 20.5H7.5a1 1 0 1 1 0-2H9a2 2 0 0 0 2-2V13H9.75a1 1 0 1 1 0-2H11V7.5a2 2 0 0 0-2-2H7.5a1 1 0 0 1-1-1"
  })));
};
export default SvgIconCursorText;